import React from 'react';
import { MuiTextField } from 'components/Shared';

export default ({ innerRef }) => [{
  key: 'reviewer-actions-taken',
  control: (
    <MuiTextField
      placeholder={'enter a comment...'}
      inputRef={innerRef}
      multiline
      fullWidth
    />
  )
}];